import react, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {Field, Form, Formik} from "formik";
import {useUser} from "../../../contexts/UserContext";
import {useModal} from "../../../contexts/ModalContext";
import React from "react";
import AxiosConfig from "../../../services/AxiosConfig";
import {validActivite} from "../../../services/ActivitesService";
import loginForm from "../../Login/LoginForm";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExclamationCircle} from "@fortawesome/free-solid-svg-icons";
import {faOptinMonster} from "@fortawesome/free-brands-svg-icons";
import form_styles from "../../Form/Form.module.css";
import FieldCustom from "../../Field/FieldCustom";
import BtnSave from "../../Button/BtnSave";
import FieldCheckboxArray from "../../Field/FieldCheckboxArray";
import styles from "../../../pages/Admin/Admin.module.css";

function RoleCreation({role}) {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const formikRef = React.useRef();
    const [justificatifTypes, setJustificatifTypes] = useState([]);
    const [selectedJustificatifs, setSelectedJustificatifs] = useState([]);

    const handleSuccess = (children = "Enregistré avec succès") => {
        showModal('success', {children: children, timeout: 5000});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 5000});
    };

    useEffect(() => {
        const fetchThat = async () => {
            const response = await AxiosConfig.get(`/admin/justificatifs/types`);
            setJustificatifTypes(response.data.myJustificatifTypes);
        };

        fetchThat();
    }, []);

    useEffect(() => {
        if (role && role.justificatifs) {
            const justIds = role.justificatifs.map(just => just.justId.toString());
            setSelectedJustificatifs(justIds);
        }
    }, [role]);

    const initialValues = {
        justificatifTypes: selectedJustificatifs || [],
        role: role?.role || "",
    };

    const handleSubmit = async (values, {setSubmitting}) => {
        try {
            const response = await AxiosConfig.post(`/admin/roles/creation`, values);
            if (response.data.success) {
                handleSuccess(response.data.message);
            } else {
                handleError(response.data.error);
            }
        } catch (error) {
            console.error(error);
            handleError(error.message);
        } finally {
            setSubmitting(false);
        }
    };


    return (
        <div className={styles.viewBloc}>
            <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
                {({values, setFieldValue, isSubmitting}) => (
                    <Form>
                        <p>Justificatifs associés à ce rôle :</p>
                        <ul>
                            {justificatifTypes.map((justificatifType, index) => (
                                <li key={index}>
                                    <label style={{display: "flex", flexDirection: "row", gap: "6px"}}>
                                        <FieldCheckboxArray label={""} name={"justificatifTypes"}
                                                            value={justificatifType.justId.toString()}
                                                            checked={values.justificatifTypes.includes(justificatifType.justId.toString())}
                                                            onChange={(e) => {
                                                                if (e.target.checked) {
                                                                    setFieldValue("justificatifTypes", [...values.justificatifTypes, e.target.value]);
                                                                } else {
                                                                    setFieldValue("justificatifTypes", values.justificatifTypes.filter(id => id !== e.target.value));
                                                                }
                                                            }}/>
                                        <Link to={`/admin/justificatifs/types/${justificatifType.justId}`}>{justificatifType.justLabel}</Link>
                                        <span>
                                        {justificatifType.justObligatoire ?
                                            <FontAwesomeIcon icon={faExclamationCircle} title={"Obligatoire"}/> : null
                                        }
                                        </span>
                                        {/*
                                                                                <Field type="checkbox"
                                               name="justificatifTypes"
                                               value={justificatifType.justId.toString()}
                                               checked={values.justificatifTypes.includes(justificatifType.justId.toString())}
                                               onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setFieldValue("justificatifTypes", [...values.justificatifTypes, e.target.value]);
                                                    } else {
                                                        setFieldValue("justificatifTypes", values.justificatifTypes.filter(id => id !== e.target.value));
                                                    }
                                                }}/>
                                        <Link to={`/admin/justificatifs/types/${justificatifType.justId}`}>{justificatifType.justLabel}</Link>
                                        <span>{justificatifType.justObligatoire ?
                                            <FontAwesomeIcon icon={faExclamationCircle} title={"Obligatoire"}/> : null}
                                        </span>
                                        */}
                                    </label>
                                </li>
                            ))}
                        </ul>

                        <Field type={"hidden"} name={"role"}/>

                        <BtnSave isSubmitting={isSubmitting}/>
                    </Form>
                )}
            </Formik>
        </div>
    );
}

export default RoleCreation;